import React from 'react';
import { TextBox } from '../../../components/ui/TextBox';
import { Button } from '../../../components/ui/Button';

export type CreateViewProps = {
  form: {
    // custom name to save in DB
    filename: string;
    // first video name (uploaded name)
    sourceFilename: string;
  };
  durationSec?: number;
  setField: <K extends keyof CreateViewProps['form']>(key: K, value: CreateViewProps['form'][K]) => void;
  onUpload: (file: File) => Promise<void> | void;
  onSubmit: () => void;
  onCancel: () => void;
  loading?: boolean;
  uploading?: boolean;
  error?: string | null;
};

export const VideoCreateView: React.FC<CreateViewProps> = ({ form, durationSec, setField, onUpload, onSubmit, onCancel, loading, uploading, error }) => {
 console.log(durationSec);
  const canSave = Boolean(form.filename && form.sourceFilename && !uploading && !loading);
  return (
    <div className="mx-auto max-w-2xl">
      <h1 className="mb-3 text-xl font-semibold">Upload Video</h1>
      <div className="space-y-3">
        <TextBox style={{display: "none"}} label="" value={form.sourceFilename} onChange={e => setField('sourceFilename', e.target.value)} required />
        <TextBox label="Filename" value={form.filename} onChange={e => setField('filename', e.target.value)} required />

        <div>
          <label className="mb-1 block text-sm font-medium">Video File</label>
          <input
            type="file"
            accept="video/*"
            onChange={e => {
              const f = e.target.files?.[0];
              if (f) onUpload(f);
            }}
            disabled={Boolean(uploading || loading)}
            className="block w-full rounded border border-input bg-background p-2 text-sm"
          />
          <div className="mt-1 text-xs text-muted-foreground">Select a video file to upload. It will be saved using the first video name. On save, it will be renamed to the custom name.</div>
          {uploading && <div className="mt-1 text-xs text-foreground">Uploading...</div>}
        </div>
      </div>
      {error && <div className="mt-3 text-sm text-destructive">{error}</div>}
      <div className="mt-4 flex gap-2">
        <Button onClick={onSubmit} disabled={!canSave}>{loading ? 'Saving...' : 'Save'}</Button>
        <Button variant="outline" onClick={onCancel}>Cancel</Button>
      </div>
    </div>
  );
};

export default VideoCreateView;
